//Notes:
//This code adds two classes to divs that don't have class names of id's. 
//And wraps the CTA en price info in a bundle in a new div. 
//It's done so that we can then style it in the theme.css

document.addEventListener("DOMContentLoaded", function () {
  let timeout;
  const observer = new MutationObserver(() => {
    if (timeout) {
      return;
    }
    timeout = setTimeout(() => {
      const parentContainers = document.querySelectorAll(
        ".bndlr-inner-products-container"
      );

      parentContainers.forEach((container) => {
        if (container.firstChild) {
          const parentElement = container.firstChild;
          const newClassName = "bundler-products-wrapper";
          if (parentElement.classList.contains(newClassName)) {
            return;
          }
          parentElement.classList.add(newClassName);
          const totalPriceDiv = container.querySelector(".bndlr-total-price");
          const addToCartDiv = container.querySelector(".bndlr-add-to-cart");
          if (totalPriceDiv && addToCartDiv) {
            const parentElement = totalPriceDiv.parentNode;

            const wrapperDiv = document.createElement("div");
            wrapperDiv.classList.add("bundler-products-add-to-cart");
            wrapperDiv.appendChild(totalPriceDiv);
            wrapperDiv.appendChild(addToCartDiv);
            if (parentElement) {
              parentElement.appendChild(wrapperDiv);
            }
          }
        }
      });
      timeout = null;
    }, 100);
  });

  observer.observe(document.querySelector("#bundler-target-element"), {
    childList: true,
    subtree: true,
  });
});
